import React, { Component } from "react";
import PropTypes from "prop-types";

class TrapFocus extends Component {
  /* istanbul ignore next */
  componentWillReceiveProps(nextProps) {
    const willTrap = nextProps.trapFocus;
    const wasTrapped = this.props.trapFocus;

    if (willTrap === wasTrapped) return;

    // using focusin instead of focus since focusin event bubbles
    // will not work in firefox 51
    if (willTrap) {
      document.addEventListener("focusin", this.onFocus);
    } else {
      document.removeEventListener("focusin", this.onFocus);
    }
  }

  onFocus /* istanbul ignore next */ = event => {
    if (!this.containerEl.contains(event.target)) {
      event.stopPropagation();
      this.containerEl.focus();
    }
  };

  render() {
    const { props } = this;

    return (
      <div
        className={props.className}
        data-auto-id={props.testId}
        tabIndex="-1"
        ref={containerEl => (this.containerEl = containerEl)}
      >
        {this.props.children}
      </div>
    );
  }
}

TrapFocus.defaultProps = {
  className: "",
  testId: ""
};

TrapFocus.propTypes = {
  trapFocus: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  testId: PropTypes.string
};

export default TrapFocus;
